export default __webpack_public_path__ + "static/media/available.c95eff6a.png";